import { ORPCError } from '@orpc/client'

/** TanStack Query's default retry count. */
const MAX_RETRIES = 3

function statusOf(error: unknown): number | undefined {
  if (error instanceof ORPCError) {
    return error.status
  }
  if (
    typeof error === 'object' &&
    error !== null &&
    'statusCode' in error &&
    typeof error.statusCode === 'number'
  ) {
    return error.statusCode
  }
  return undefined
}

/**
 * Query `retry`: client errors (4xx, e.g. a missing record or no access) fail
 * at once, they would fail again; network and server errors retry as usual.
 */
export function shouldRetryQuery(failureCount: number, error: unknown) {
  const status = statusOf(error)
  if (status !== undefined && status >= 400 && status < 500) {
    return false
  }
  return failureCount < MAX_RETRIES
}
